import { Controller } from '@hotwired/stimulus'

export default class PopoverController extends Controller {
  static targets = ['container', 'content', 'title', 'trigger'];

  static values = {
    visible: { type: Boolean, default: false },
    mobileBreakpoint: { type: Number, default: 577 },
    offsetY: { type: Number, default: 12 }
  }

  initialize() {
    this.popover = new bootstrap.Popover(this.containerTarget, {
      html: true,
      placement: 'bottom',
      title: this.titleTarget,
      content: this.contentTarget,
      container: this.element,
      trigger: 'manual',
      fallbackPlacements: [],
      offset: this.calculateOffset.bind(this),
    });
  }

  disconnect() {
    if (this.popover) {
      this.popover.dispose();
      this.popover = null;
    }
  }

  toggle() {
    this.visibleValue ? this.close() : this.open();
  }

  open() {
    if (this.hasContentTarget) this.contentTarget.classList.remove('d-none');
    if (this.hasTitleTarget) this.titleTarget.classList.remove('d-none');

    requestAnimationFrame(() => this.showPopover());
  }

  showPopover() {
    if (this.popover) {
      this.popover.show();
      this.visibleValue = true;
      this.focusFirstElement();
    }
  }

  close() {
    if (this.popover) {
      this.popover.hide();
    }
    this.visibleValue = false;

    if (this.hasTriggerTarget) {
      this.triggerTarget.setAttribute('aria-expanded', 'false');
      this.triggerTarget.focus();
    }
  }

  calculateOffset({ placement, reference }) {
    if (placement !== 'bottom') return [];

    const isMobile = window.innerWidth < this.mobileBreakpointValue;
    if (isMobile) {
      return [0, this.offsetYValue];
    }

    const offset = reference.width > 120 ? -reference.width + 66 : -reference.width + 36;
    return [offset, this.offsetYValue];
  }

  focusFirstElement() {
    if (!this.hasContentTarget) return;

    const firstFocusableElement = this.contentTarget.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    if (firstFocusableElement) {
      firstFocusableElement.focus();
    }
  }
}
